import { makeStyles } from '@rbx/ui';

const useReferenceDescriptionStyles = makeStyles()((theme) => ({
  boxBottomSpacing: {
    marginBottom: theme.spacing(3),
  },
}));

export default useReferenceDescriptionStyles;
